import { render, staticRenderFns } from "./kyc-chart-graph.vue?vue&type=template&id=e282a0c6&"
import script from "./kyc-chart-graph.vue?vue&type=script&lang=js&"
export * from "./kyc-chart-graph.vue?vue&type=script&lang=js&"
import style0 from "./kyc-chart-graph.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../tmp/ffsecurity-ui/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports